import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Table } from "react-bootstrap";
import "./_attendanceReport.scss";
import moment from 'moment';
import AttendanceModal from './attendanceModal';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";



class TableData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attendanceModal: false,
            section_id: 0,
            startDateInput: moment.unix(this.props.stateData.startDateCalender).format("YYYY-MM-DD"),
            endDateInput: moment.unix(this.props.stateData.endDateCalender).format("YYYY-MM-DD"),
            dateArrayfinal: [],
            getStudenWiseAttendanceData: [],
            loader: 0,

            mainTableStartDate: moment.unix(this.props.stateData.startDateCalender).format("DD-MM-YYYY"),
            mainTableEndDate: moment.unix(this.props.stateData.endDateCalender).format("DD-MM-YYYY")

        };
    }

    componentDidMount() {
        var dateArray = [];
        var currentDate = moment(this.state.startDateInput);
        var stopDate = moment(this.state.endDateInput);
        while (currentDate <= stopDate) {
            dateArray.push(moment(currentDate).format('DD-MM-YYYY'))
            currentDate = moment(currentDate).add(1, 'days');
        }
        this.setState({ dateArrayfinal: dateArray })
    }

    sectionWiseData = async (sectionId, classId, branchId) => {
        this.setState({ attendanceModal: true, section_id: sectionId, loader: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($section_id:Int, $class_id:Int, $startTime:String, $endTime:String, $institute_id:Int,$branch_id:Int){
                getStudenWiseAttendanceData(
                    section_id: $section_id
                    class_id: $class_id
                    startTime: $startTime
                    endTime: $endTime
                    institute_id: $institute_id
                    branch_id:$branch_id
                  ) {
                    student_name
                    class_name
                    section_name
                    roll_no
                    total_days
                    total_absent
                    total_present
                    total_holidays
                    attenedance_percentage
                    dayWiseData {
                      date
                      attendance_status
                    }
            }
        }
            `,
            variables: {
                section_id: parseInt(sectionId),
                class_id: parseInt(classId),
                startTime: this.props.stateData.startDateCalender.toString(),
                endTime: this.props.stateData.endDateCalender.toString(),
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.props.stateData.branchSearch)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getStudenWiseAttendanceData.length > 0) {
            this.setState({
                getStudenWiseAttendanceData: result.data.getStudenWiseAttendanceData,
                loader: 0
            })
        } else {
            this.setState({
                getStudenWiseAttendanceData: [],
                loader: 0
            })
        }
    }

    render() {
        console.log("this.props", this.state.getStudenWiseAttendanceData);

        let presentAndAbsent = [{ status: "Present" }, { status: "Absent" }, { status: "Sick" }];

        return (
            <section className="table_data">
                <div className="scrollmenu">

                    <Container>
                        <Col xl={12} lg={12} md={12} >
                            <Table className="mb-0 ">
                                <thead>
                                    <tr>
                                        <th rowSpan="2" >Date</th>
                                        <th rowSpan="2" >Class/Exam/Section</th>
                                        <th rowSpan="2">No.Of.Students</th>
                                        {
                                            this.props.attendanceTypes.map((item) => {
                                                return (<th colSpan="3">{item.label}</th>)
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        {
                                            this.props.attendanceTypes.map((item) => {
                                                return (
                                                    presentAndAbsent.map((item1) => {
                                                        return (<th>{item1.status}</th>)
                                                    })
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.stateData.attendanceData != undefined && this.props.stateData.attendanceData.length > 0 ? (
                                            this.props.stateData.attendanceData.map((item) => {
                                                console.log("itemssss", item);
                                                let date = moment.unix(item.date).format("DD-MM-YYYY")
                                                return (<>
                                                    <tr>
                                                        <td>{this.state.mainTableStartDate + "   To   " + this.state.mainTableEndDate}</td>
                                                        <td onClick={() => this.sectionWiseData(item.section_id, item.class_id)} className="section_name">{item.ces}</td>
                                                        <td>{item.sectionWiseStdCount}</td>
                                                        {
                                                            item.data != null ? (

                                                                this.props.attendanceTypes.map((item1) => {
                                                                    let filterCallWise = item.data.filter((item2) => item1.value == item2.attendance_subtype_id)
                                                                    if (filterCallWise.length > 0) {
                                                                        return (
                                                                            filterCallWise.map((item3) => {
                                                                                return (
                                                                                    <>
                                                                                        <td>{item3.present}</td>
                                                                                        <td>{item3.absent}</td>
                                                                                        <td>{item3.sick}</td>
                                                                                    </>
                                                                                )
                                                                            })
                                                                        )
                                                                    } else {

                                                                        return (
                                                                            <>
                                                                                <td>{"-"}</td>
                                                                                <td>{"-"}</td>
                                                                                <td>{"-"}</td>
                                                                            </>
                                                                        )
                                                                    }

                                                                })
                                                            ) : (

                                                                this.props.attendanceTypes.map((item) => {
                                                                    return (
                                                                        <>
                                                                            <td>-</td>
                                                                            <td>-</td>
                                                                            <td>-</td>
                                                                        </>
                                                                    )

                                                                })

                                                            )
                                                        }
                                                    </tr>
                                                </>
                                                )
                                            })
                                        ) : ("")
                                    }
                                </tbody>
                            </Table>
                        </Col>

                        <AttendanceModal
                            show={this.state.attendanceModal}
                            onHide={() => this.setState({ attendanceModal: false, loader: 0 })}
                            stateData={this.state}
                        />
                    </Container>
                </div>
            </section>
        );
    }
}


export default withRouter(withApollo(compose()(TableData)));